<template>
  <div
    v-if="courseDetail && Object.keys(courseDetail).length"
    class="course-detail"
    ref="course-detail"
  >
    <bread-crumb :courseInfoModule="courseDetail.courseInfoModule" />
    <div
      class="course-detail__left"
      ref="courseDetailLeft"
    >
      <detail-card
        :courseInfoModule="courseDetail.courseInfoModule"
        :teacherModule="courseDetail.teacherModule"
        :freeAuditionModule="courseDetail.freeAuditionModule"
      />
      <div
        class="detail-content-container course-detail__left__content"
        ref="detailContent"
      >
        <detail-content
          @clickPoint="clickPoint"
          :contentTabFixed="contentTabFixed"
          :tabInfo="tabInfo"
          :courseDetail="courseDetail"
        ></detail-content>
        <div class="tab-container">
          <div
            ref="courseOutline"
            v-if="showOutline"
          >
            <course-outline
              :syllabusModule="courseDetail.syllabusModule"
              :validDay="courseDetail.courseInfoModule.validDay"
            />
          </div>
          <div ref="courseParticulars" v-if="courseDetail.brochureModule && courseDetail.brochureModule.brochures">
            <course-particulars :brochureModule="courseDetail.brochureModule" />
          </div>
        </div>
      </div>
    </div>
    <div
      class="course-detail__right02"
      :class="{ isFixed: rightBoxFixed}"
    >
      <detail-right :courseDetail="courseDetail" />
      <!-- 运营位     -->
      <div
        class="operate-location"
        v-if="courseDetail.operateLocationModule && Object.keys(courseDetail.operateLocationModule).length"
        :courseDetail="courseDetail"
      >
        <operate-location :operateLocationModule="courseDetail.operateLocationModule"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import titleMinxin from '@/util/title'
import types from '@/views/NewCourseDetail/store/types'
import detailComponents from './modules'
// import detailData from './mock/detail.json'

export default {
  name: "new-course-detail",
  components: {
    ...detailComponents
  },
  mixins: [titleMinxin],
  data() {
    return {
      rightBoxFixed: false,
      tabInfo: [],
      contentTabFixed: false,
      isClickPoint: false,
      currentIndex: 0,
      backToCourseCenter: {}, // 返回选课中心需要的参数
      // courseDetail: detailData.data
    }
  },
  title() {
    return this.documentTitle
  },
  asyncData({ store, route }) {
    const { dispatch } = store
    return Promise.all([dispatch(types.GET_NEW_COURSE_DETAIL, { route })])
  },
  provide: function() {
    return {
      initTabInfo: this.initTabInfo
    }
  },
  computed: {
    ...mapState({
      courseDetail: state => state.NewCourseDetail.courseDetail,
      userIsLogin: state => state.userIsLogin,
      dataLoading: state => state.NewCourseDetail.dataLoading
    }),
    documentTitle() {
      if (this.courseDetail && this.courseDetail.name) {
        return this.courseDetail.name + '-学而思网校'
      }
      return '学而思网校'
    },
    showOutline() {
      if (!this.courseDetail) return
      if (this.courseDetail && this.courseDetail.syllabusModule && this.courseDetail.syllabusModule.count) {
        return Number(this.courseDetail.syllabusModule.count) > 0
      }
    },
  },
  async mounted() {
    if (this.courseDetail && this.courseDetail.length <= 0) {
      window.location.replace('https://online.xueersi.com')
    } else {
      this.$nextTick(() => {
        this.getDataLoading(false)
        this.setCommonLog()
        // 链接上增加sGroupId 带到登录页
        this.addSgroupIdToUrl()

        this.initTabInfo()
        window.addEventListener('scroll', this.handleScroll)
      })
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    clearInterval(this.timer)
    clearInterval(this.depositEndTimer)
  },
  methods: {
    ...mapMutations({
      getDataLoading: types.SET_DATA_LOADING
    }),
    ...mapActions({
      getCartCount: types.GET_CART_COUNT
    }),
    setCommonLog() {
      if (this.courseDetail && this.courseDetail.teacherModule) {
        const { chinaTeacher = [], foreignTeacher = [], counsolerInfo = [] } = this.courseDetail.teacherModule
        const teacherList = []
        if (chinaTeacher && chinaTeacher.length)  {
          teacherList.push(...chinaTeacher)
        }
        if (foreignTeacher && foreignTeacher.length)  {
          teacherList.push(...foreignTeacher)
        }
        if (counsolerInfo && counsolerInfo.length)  {
          teacherList.push(...counsolerInfo)
        }
        const teacherId = teacherList.length && teacherList.map((item) => item.id)

        const { courseInfoModule: { courseId, subjectIds, gradeIds }, priceModule, logModule } = this.courseDetail

        const commonLog = {
          course_id: courseId,
          subject_id: subjectIds,
          grade_id: gradeIds,
          local_time: new Date(),
          teacher_id: (teacherId && teacherId.join()) || '',
          course_price: Object.keys(priceModule).length && priceModule.resale,
          sgroupid: Object.keys(logModule).sGroupId || '',
          promotionid: logModule.promotionId || '',
          promotionType: logModule.promotionType || ''
        }
        this.$xesLogger.opts.param = commonLog
        this.$xesLogger.loadMsg({ show: 'course-detail-page-pv' })
      }
    },
    addSgroupIdToUrl() {
      // 链接上拼上sGroupId 然后带到登录页
      const currentUrl = window.location.href
      let path = window.location.href
      const sGroupId = (this.courseDetail && this.courseDetail.logModule && this.courseDetail.logModule.sGroupId) || ''
      if (currentUrl.indexOf('sGroupId') === -1) {
        if (currentUrl.indexOf('?') === -1) {
          path = `${currentUrl}?sGroupId=${sGroupId}`
        } else {
          path = `${currentUrl}&sGroupId=${sGroupId}`
        }
      }

      history.replaceState('course-detail', '', `${path}`)
    },
    initTabInfo() {
      this.tabInfo = []
      const top = this.$refs.detailContent && this.$refs.detailContent.offsetTop
      if (this.showOutline) {
        this.tabInfo.push({
          name: '课程大纲',
          id: 'courseOutline',
          show: false,
          top: top
        })
      }
      if (this.$refs.courseParticulars) {
        this.tabInfo.push({
          name: '课程详情',
          id: 'courseParticulars',
          show: false,
          top: this.$refs.courseParticulars.offsetTop + top - 100
        })
      }
      if (this.tabInfo.length) {
        this.tabInfo[0].show = true
      }
    },
    scrollArriveBtm(dom) {
      const innerHeight = Math.ceil(window.innerHeight)
      const scrollY = Math.ceil(window.scrollY)
      const scrollHeight = document.body.scrollHeight
      if (scrollHeight === scrollY + innerHeight) {
        // 到达底部 发送日志
        this.$xesLogger.loadMsg({ key: 'xeslog-arrivebuttom-courseDetail', target: dom })
      }
    },
    clickPoint(index) {
      this.isClickPoint = true
      this.currentIndex = index
      this.clearTabInfo()
      this.tabInfo[this.currentIndex].show = true
    },
    clearTabInfo() {
      for (let i = 0; i < this.tabInfo.length; i++) {
        this.tabInfo[i].show = false
      }
    },
    handleScroll() {
      if (this.isClickPoint) {
        this.isClickPoint = false
        this.contentTabFixed = true
        this.rightBoxFixed = true
        return
      }
      let st =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      // 右侧框保持在视图内
      let leftBox = this.$refs.courseDetailLeft && this.$refs.courseDetailLeft.parentNode
      let detailContent = this.$refs.detailContent
      if (!leftBox || !detailContent) return
      // 47是面包屑的高度 94: 导航的高度
      let boxOffsetTop = leftBox.offsetTop + 47
      let detailContentOT = detailContent.offsetTop + leftBox.offsetTop
      if (st > boxOffsetTop) {
        this.rightBoxFixed = true
      } else {
        this.rightBoxFixed = false
      }
      if (st > detailContentOT) {
        this.contentTabFixed = true
      } else {
        this.contentTabFixed = false
      }
      const dom = this.$refs.courseDetail
      this.scrollArriveBtm(dom)

      const scrollHeight =
        document.documentElement.scrollHeight - document.documentElement.clientHeight
      const length = this.tabInfo.length
      const height = 130
      this.clearTabInfo()
      if (st < this.tabInfo[0].top + height) {
        this.tabInfo[0].show = true
        return
      }
      if (st > this.tabInfo[length - 1].top + height) {
        this.tabInfo[length - 1].show = true
        return
      }
      if (st === scrollHeight) {
        this.tabInfo[length - 1].show = true
        return
      }
      for (let i = 0; i < length; i++) {
        const cur = this.tabInfo[i]
        const nextIndex = i + 1
        const next = this.tabInfo[nextIndex]
        if (st >= cur.top + height && next && st < next.top + height) {
          cur.show = true
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import 'src/scss/entry';
@import './index.scss';
@import './common.scss';
.course-detail__left__content {
  padding: 0;
  // min-height: 660px;
  padding-bottom: 20px;
  margin-bottom: 40px;
  z-index: 0;
}
.tab-container {
  padding: 0 20px;
}
.course-detail > div {
  display: inline-block;
}
.course-detail__right02 {
  position: absolute;
  top: 56px;
  width: 360px;
  margin: 0;
  padding: 0;
  border-top: 2px solid #ff3334;
}
.isFixed {
  position: fixed;
  top: 104px;
}
.operate-location {
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/index.vue